import React, { useCallback, useState, useEffect } from 'react';

import QuestionPreviewContainer from '@ts-core/modules/exercises/components/QuestionPreviewContainer';
import FillInTheBlanksQuestionText from '@ts-core/modules/fillInTheBlanksExercises/components/FillInTheBlanksQuestionText';
import FillInTheBlanksQuestionBlank from '@ts-core/modules/fillInTheBlanksExercises/components/FillInTheBlanksQuestionBlank';

import { CoreFillInTheBlanksQuestionOption } from '@ts-core/modules/fillInTheBlanksExercises/types';

import { FillInTheBlanksQuestion } from '../../types';

interface FillInTheBlanksQuestionInputProps {
  question?: FillInTheBlanksQuestion;
  loading?: boolean;

  onChangeBlank: (question: FillInTheBlanksQuestion, input: Record<string, string>) => void;
}

function FillInTheBlanksQuestionInput(props: FillInTheBlanksQuestionInputProps) {
  const { question, loading, onChangeBlank } = props;
  const [blanks, setBlanks] = useState<Record<string, string>>({});

  const handleChangeBlank = useCallback((blank: CoreFillInTheBlanksQuestionOption, value: string) => {
    setBlanks((state) => ({
      ...state,
      [blank._id]: value,
    }));
  }, []);

  useEffect(() => {
    if (question) {
      onChangeBlank(question, blanks);
    }
  }, [question, blanks, onChangeBlank]);

  return (
    <QuestionPreviewContainer noColors>
      <FillInTheBlanksQuestionText
        question={question}
        loading={loading}
        renderBlank={(blank) => (
          <FillInTheBlanksQuestionBlank key={blank._id} noColors blank={blank} onChange={handleChangeBlank} answerText={blanks[blank._id]} />
        )}
      />
    </QuestionPreviewContainer>
  );
}

export default FillInTheBlanksQuestionInput;
